import { render, staticRenderFns } from "./PregledPutnihNaloga.vue?vue&type=template&id=41decce3&scoped=true&"
import script from "./PregledPutnihNaloga.vue?vue&type=script&lang=ts&"
export * from "./PregledPutnihNaloga.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41decce3",
  null
  
)

export default component.exports